import {type IAsset} from '../schema';
import {isVideoFileTypeAsset} from '../utils';

export const assetHasConstituentKeyframes = (
	asset?: IAsset,
): asset is IAsset => {
	return (
		!!asset &&
		isVideoFileTypeAsset(asset.fileFormatFamily) &&
		asset.constituentIds.length > 0
	);
};
